import { atom } from "recoil"
import { UserDetail } from '../connector/type';
import { ProjectStatus } from "./roomDetail";

const defaultUserDetail: UserDetail = {
  id: '',
  nickname: '',
  level: 0,
  hasThumbnail: false,
  todayComment: '',
  gasMask: false,
  familyNickname: '',
  decorationItem: false,
  maxStreak: 0,
  sniperItem: false,
}

const roomsState = atom({
  key: 'rooms',
  default: [{
    id: '',
    owner: '',
    participants: 0,
    uniqueParticipants: 0,
    name: '',
    description: '',
    maxParticipants: 0,
    isProject: false,
    projectPrice: 0,
    projectStatus: ProjectStatus.NONE_PROJECT,
    projectType: '',
    projectStartAmount: 0,
    projectTargetAmount: 0,
    projectAmount: 0,
    projectParticipants: [''],
    isSecret: false,
    ownerDetail: defaultUserDetail,
    record: {
      win: 0,
      defeat: 0,
    },
    recommenders: [''],
    giftedBullets: 0,
    managers: [''],
    isAllFreezing: false,
  }]
});

export default roomsState;